package world.phantasmal.web.core

enum class PwToolType(val uiName: String, val slug: String) {
    Viewer("Viewer", "viewer"),
    QuestEditor("Quest Editor", "quest_editor"),
    HuntOptimizer("Hunt Optimizer", "hunt_optimizer"),
}
